import angular from 'angular';

import { MovimentacoesAdmissoesFormComponent } from './components/form/movimentacoes-admissoes-form.component';
import { MovimentacoesAdmissoesComponent } from './components/listagem/movimentacoes-admissoes.component';
import { MovimentacoesAdmissoesFormModalController } from './modals/form/movimentacoes-admissoes-form.modal.controller';
import { MovimentacoesAdmissoesFormModalService } from './modals/form/movimentacoes-admissoes-form.modal.service';
import { MovimentacoesAdmissoesService } from './movimentacoes-admissoes.service';

export const MeurhMovimentacoesAdmissoesModule = angular.module('MeurhMovimentacoesAdmissoesModule', [])
    .controller('MovimentacoesAdmissoesFormModalController', MovimentacoesAdmissoesFormModalController)
    .component('meurhMovimentacoesAdmissoesForm', MovimentacoesAdmissoesFormComponent)
    .component('meurhMovimentacoesAdmissoesComponent', MovimentacoesAdmissoesComponent)
    .service('MovimentacoesAdmissoesFormModalService', MovimentacoesAdmissoesFormModalService)
    .service('MovimentacoesAdmissoesService', MovimentacoesAdmissoesService)
    .name;
